import { actions } from './../../../utils/constants'


export const clearToken = () => ({
    type: actions.CLEAR_TOKEN
})

export const asyncAllInfos = () => ({
    type: actions.SET_ASYNC_SYNC
})

export const setGlobalInfo = () => ({
    type: actions.SET_ASYNC_GLOBAL
})

export const setLocalInfo = () => ({
    type: actions.SET_ASYNC_LOCAL
})

export const setCoachesArray = () => ({
    type: actions.SET_ASYNC_COACHES
});



// WEBPACK FOOTER //
// ./src/App/containers/dashboard/dashboard.actions.js